import React from "react";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { FileSpreadsheet } from "lucide-react";

interface ExportToExcelProps {
  data: Record<string, any>[];
  fileName?: string;
  buttonText?: string;
  className?: string;
}

const ExportToExcel: React.FC<ExportToExcelProps> = ({
  data,
  fileName = "exported_data",
  buttonText = "Export Attendee Sheet (.CSV)",
  className,
}) => {
  const exportFile = () => {
    if (data.length === 0) {
      alert("No data available to export.");
      return;
    }

    try {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(file, `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("An error occurred while exporting the data.");
    }
  };

  return (
    <button
      onClick={exportFile}
      className={className || "contact-export-btn"}
      aria-label={buttonText}
      title={buttonText}
    >
      <FileSpreadsheet size={16} style={{ color: '#F79B59' }} />
      <span>{buttonText}</span>
    </button>
  );
};

export default ExportToExcel;